import { site } from '@panel/commons/helpers';

const siteId = site.id;

function module1BodyManager(data) {
  const body = {};

  if (data.postingId) {
    body.postingId = data.postingId;
  }

  body.real_estate_type_id = data.propertyType;
  body.real_estate_sub_type_id = data.propertySubType ? data.propertySubType : null;
  body.price_operation_type = [
    {
      operation_type: data.operationType
    }
  ];

  return body;
}

function module2BodyManager(data) {
  const body = {};
  body.address = data.addressVal;

  const [latitude, longitude] = data.coordinates.split(',');
  body.coordinates = [parseFloat(longitude), parseFloat(latitude)];
  body.geolocation_visibility = data.addressType;
  if (data.cep) {
    body.postal_code = data.cep;
  }

  if (data.addressComplement || data.addressComplement === '') {
    body.addressComplement = data.addressComplement;
  }

  if (data.subDistrictVal) {
    body.location_id = data.subDistrictVal;
  } else if (data.districtVal) {
    body.location_id = data.districtVal;
  } else {
    body.location_id = data.cityVal;
  }

  return body;
}

const nonFeatures = [
  'title',
  'description',
  'numberOfYears',
  'CFT5',
  'hasValues',
  'price',
  'postingId',
  'operationType',
  'CFT400'
];

function module4BodyManager(data) {
  const filterCFT400 = ['IWBR', 'WIBR', 'ICBR'];
  const body = {};
  body.features = [];

  Object.keys(data).forEach(key => {
    if (!nonFeatures.includes(key)) {
      let ft = { feature_id: key };
      if (Object.prototype.hasOwnProperty.call(data[key], 'value')) {
        ft = { ...ft, ...data[key] };
      } else {
        ft.value = data[key];
      }
      body.features.push(ft);
    }
  });
  if (parseInt(data.CFT5, 10) === 1) {
    body.features.push({ feature_id: 'CFT5', value: data.numberOfYears });
  } else {
    body.features.push({ feature_id: 'CFT5', value: data.CFT5 });
  }

  if (filterCFT400.includes(siteId)) {
    body.features.push({ feature_id: 'CFT400', value: data.CFT400.value });
  }

  if (data.postingId !== '') {
    body.postingId = data.postingId;
  }
  body.title = data.title;
  body.description = data.description;
  body.price_operation_type = [
    {
      prices: Array.isArray(data.price)
        ? data.price.map(p => ({
            amount: parseInt(p.value, 10),
            currency: p.value_unit
          }))
        : [{ amount: parseInt(data.price.value, 10), currency: data.price.value_unit }]
    }
  ];
  return body;
}

function step3BodyManager(updatedFeatures, originalFeatures, postingId, data) {
  const body = { postingId, features: [] };

  const { featureChecks, featureSelect, featureInputs } = updatedFeatures;
  const featureChecksOriginals = originalFeatures.featureChecks;
  const featureSelectOriginals = originalFeatures.featureSelect;
  const featureInputsOriginals = originalFeatures.featureInputs;

  featureChecks.map(updated => {
    if (updated.touched) {
      if (featureChecksOriginals.find(original => original.id === updated.id).isChecked !== updated.isChecked) {
        body.features.push({ feature_id: updated.id, value: updated.isChecked });
      }
    }
    return null;
  });

  featureSelect.map(updated => {
    if (updated.touched) {
      if (featureSelectOriginals.find(original => original.id === updated.id).value !== updated.value) {
        body.features.push({ feature_id: updated.id, value: updated.value ? updated.value : '0' });
      }
    }
    return null;
  });

  featureInputs.map(feature => {
    if (data[feature.id] !== feature.value) {
      body.features.push({ feature_id: feature.id, value: data[feature.id] ? data[feature.id] : '0' });
    }
    return null;
  });

  return body;
}

export { module1BodyManager, module2BodyManager, module4BodyManager, step3BodyManager };
